import moment from 'moment';
import 'moment-timezone';
import { userService } from '../_services/user.service';

export const DateTimeHelper = {
    getUsersDateTimeStringFromUtc,
    getUtcDateTimeStringFromUser,
    getUtcNow,
    getUsersNow
}

// export const formatDate;

export const formatDate = (date, includeYear) => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    if (includeYear)
        return [month, day, year].join('-');

    return [month, day].join('/');
}


function getUsersDateTimeStringFromUtc(date, format) {
    moment.locale("en");
    let currentUser = userService.getLoggedInUser();
    if (currentUser == null || currentUser.timezoneIanaName == undefined)
        return moment(date).format();
    if (format !== undefined)
        return moment.tz(date, 'UTC').tz(currentUser.timezoneIanaName).format(format);
    return date == undefined ? null : moment.tz(date, 'UTC').tz(currentUser.timezoneIanaName).format();
}

function getUtcDateTimeStringFromUser(date, format) {
    moment.locale("en");
    let currentUser = userService.getLoggedInUser();
    if (currentUser == null || currentUser.timezoneIanaName == undefined)
        return moment(date).format();
    if (format !== undefined)
        return moment.tz(date, currentUser.timezoneIanaName).tz('UTC').format(format);
    return date !== null ? (typeof date === 'string' ? moment.tz(date, currentUser.timezoneIanaName).tz('UTC').format() : date.tz('UTC').format()) : null;
}

function getUtcNow(format) {
    moment.locale("en");
    if (format !== undefined)
        return moment.tz('UTC').format(format);
    return moment.tz('UTC').format();
}

function getUsersNow(format) {
    moment.locale("en");
    let currentUser = userService.getLoggedInUser();
    if (currentUser == null || currentUser.timezoneIanaName == undefined)
        return moment().format();
    if (format !== undefined)
        return moment.tz('UTC').tz(currentUser.timezoneIanaName).format(format);
    return moment.tz('UTC').tz(currentUser.timezoneIanaName).format();
}


function getUtcDateFromUser(date) {
    let currentUser = userService.getLoggedInUser();
    return typeof date === 'string' ? moment.tz(date, currentUser.timezoneIanaName).tz('UTC').format() : date.tz('UTC').format();
}